var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00049 1.34998C11.6654 1.35024 13.7857 3.49913 14.2261 6.22205H15.2808C15.9986 6.22222 16.5815 6.80399 16.5815 7.52185V15.2826C16.5814 16.0003 15.9985 16.5822 15.2808 16.5824H2.72217C2.00431 16.5824 1.42255 16.0004 1.42236 15.2826V7.52185C1.42236 6.80388 2.0042 6.22205 2.72217 6.22205H3.7749C4.21521 3.49908 6.3355 1.35014 9.00049 1.34998ZM9.00049 2.54919C6.7968 2.54939 4.88936 4.59348 4.88916 7.27185H4.63916V7.42126H2.72217C2.66694 7.42126 2.62158 7.46662 2.62158 7.52185V15.2826C2.62177 15.3377 2.66706 15.3822 2.72217 15.3822H15.2808C15.3357 15.382 15.3812 15.3376 15.3813 15.2826V7.52185C15.3813 7.46673 15.3358 7.42144 15.2808 7.42126H13.3638V7.27185H13.1118C13.1116 4.59355 11.2041 2.5495 9.00049 2.54919Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41895 16.3754H6.21973V9.39587H7.41895V16.3754ZM11.7803 16.3754H10.5811V9.39587H11.7803V16.3754ZM9 6.1781C10.6334 6.17832 11.7811 7.72535 11.7812 9.3949H10.582C10.5818 8.17408 9.77526 7.37756 9 7.37732C8.22478 7.37764 7.41913 8.17414 7.41895 9.3949H6.21973C6.21992 7.72539 7.36662 6.1784 9 6.1781Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenue);
export default __webpack_public_path__ + "static/media/venue.8c9feb38bc3e81c773bb46ebe8d2e694.svg";
export { ForwardRef as ReactComponent };